import { useContextFallback } from '@prenuvo/halo-web';

import { UserContext } from './user.context';

export const useUser = () => useContextFallback(UserContext);
